<mat-checkbox (ngModelChange)="selectedChanged($event)" [ngModel]="inputModel" [indeterminate]="indeterminate === true" >
  <ng-content></ng-content>
</mat-checkbox>
